import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import UserReply from '../components/Reply/UserReply';
import RobotReply from '../components/Reply/RobotReply';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import UnitNoInput from '../components/Input/UnitNoInput';
import CheckLoading from '../components/Loading/CheckLoading';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';
import Q2_2_1 from '../Q2_2_1';
import Q7 from '../Q7';
import Q9 from '../Q9';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import { AiTopic } from '../../../../../lib/types/AiTypes';

const Q2_2: FC<Props> = ({
  addElement,
  cabId,
  cabIsOnline,
  h5Platform,
  setTargetPage,
  setIsToSelectLockerPage,
  deviceCode,
  sessionId,
  enterPhoneNumber,
}) => {
  // 选项
  const options: {zhValue: string; enValue: string}[] = [
    { zhValue: '立即注册', enValue: 'Sign up now' },
  ];
  // 检查柜子是否在线
  const [getCabOnline] = getFoodifoxDataLazy<boolean>('/fox3PDAi/cabOnlineStatus?cabId=' + cabId);
  const [getH5OrderBoxListByUnitNo] = getFoodifoxDataLazy<AiTopic>('/fox3PDAi/getH5OrderBoxListByUnitNo');

  const send = (unitNo: string) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在查询订单…'}
        enText={'Please wait...We are confirming details.'}
        style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.58, getWindowWidth() * 0.55) }}
      />
    );

    // 发送选项给后台
    getH5OrderBoxListByUnitNo({
      param: {
        useCabId: cabId,
        roomNo: unitNo,
      },
      onCompleted({ boxNumberList: boxList, boxOfflineCode }) {
        setTimeout(() => {
          if ((boxList || []).length > 0 || (boxOfflineCode || []).length > 0) {
            // loading显示打勾
            TempFieldUtils.aiRetainLoadingIds.push(loadingFlowId);
          }
          else {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
          }
        }, 2000);
        setTimeout(() => {
          // 查询到了订单，并且柜子在线
          if ((boxList || []).length > 0 && (boxOfflineCode || []).length === 0) {
            checkOnline(boxList || [], boxOfflineCode || []);
          }
          // 查询到了订单，但是柜子离线了
          else if ((boxList || []).length > 0 && (boxOfflineCode || []).length > 0) {
            checkOnline(boxList || [], boxOfflineCode || []);
          }
          // 没有查询到订单
          else {
            addElement(
              <Q2_2_1
                cabId={cabId}
                h5Platform={h5Platform}
                addElement={addElement}
                setTargetPage={setTargetPage}
                deviceCode={deviceCode}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
        }, 2200);
      },
    });
  };

  const checkOnline = (boxList: { cabId: number; boxNumber: string }[], boxOfflineCode: { qrCode: string; boxNumber: string }[]) => {
    const loadingFlowId = uuid();
    addElement(
      <CheckLoading
        flowId={loadingFlowId}
        zhText={'请稍等…正在连接至智能柜…'}
        enText={'Please wait...We are connecting with your locker.'}
        style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.55, getWindowWidth() * 0.58) }}
      />
    );

    getCabOnline({
      onCompleted(isOnline) {
        setTimeout(() => {
          if (!isOnline) {
            // 隐藏loading
            TempFieldUtils.aiFlowIds.push(loadingFlowId);
            TempFieldUtils.aiFlowIds.push(...TempFieldUtils.aiRetainLoadingIds);
            TempFieldUtils.aiRetainLoadingIds = [];
          }
        }, 2000);
        setTimeout(() => {
          // 柜子在线
          if (isOnline) {
            addElement(
              <Q7
                boxList={boxList}
                addElement={addElement}
                setTargetPage={setTargetPage}
                cabId={cabId}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                loadingFlowId={loadingFlowId}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
          // 柜子离线了
          else {
            addElement(
              <Q9
                cabId={cabId}
                boxList={boxList}
                boxOfflineCode={boxOfflineCode}
                addElement={addElement}
                setTargetPage={setTargetPage}
                h5Platform={h5Platform}
                deviceCode={deviceCode}
                sessionId={sessionId}
                enterPhoneNumber={enterPhoneNumber}
              />
            );
          }
        }, 2500);
      }
    });
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '请在下方输入您的门牌号';
    const langEn = 'Please enter your apartment/unit number below.';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.65, getWindowWidth() * 0.6) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2-2 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          <RowLeft>
            <UnitNoInput
              flowId={flowId}
              callback={(unitNo) => {
                addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2-2 - user: ' + unitNo, sessionId);
                addElement(
                  <UserReply
                    langZh={unitNo}
                    langEn={unitNo}
                  />
                );
                send(unitNo);
              }}
            />
          </RowLeft>
        </LeftToRight>
      );
    }, 400);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  cabIsOnline: boolean;
  h5Platform: number;
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  deviceCode: string;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q2_2;
